import { render, staticRenderFns } from "./CorrectedFeedFormula.vue?vue&type=template&id=4af45acc&scoped=true"
import script from "./CorrectedFeedFormula.vue?vue&type=script&lang=js"
export * from "./CorrectedFeedFormula.vue?vue&type=script&lang=js"
import style0 from "./CorrectedFeedFormula.vue?vue&type=style&index=0&id=4af45acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af45acc",
  null
  
)

export default component.exports